import { Link } from "react-router";
import { HeroCards } from "./HeroCards";
import { useI18n } from "../i18n/I18nProvider";

/** Big "Próximamente" hero for the home page and for routes that are closed (login, checkout…). */
export function ComingSoonHero({ showShopLink = true }: { showShopLink?: boolean }) {
  const { t } = useI18n();
  return (
    <section className="soon-hero" aria-labelledby="soon-title">
      <div className="container soon-inner">
        <div className="soon-copy">
          <span className="soon-pill">
            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <path d="M12 3 2 21h20L12 3Zm0 6v5m0 3v.01" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            {t("soon.pill")}
          </span>
          <h1 id="soon-title">{t("soon.title")}</h1>
          <p>{t("soon.text")}</p>
          <ul className="soon-list">
            <li>{t("soon.point1")}</li>
            <li>{t("soon.point2")}</li>
            <li>{t("soon.point3")}</li>
          </ul>
          {showShopLink && (
            <Link to="/mercado" className="btn btn-accent btn-lg">
              {t("soon.cta")}
            </Link>
          )}
        </div>
        <HeroCards variant="soon" />
      </div>
    </section>
  );
}

/** Slim strip shown under the header on every page except home while in "Próximamente" mode. */
export function ComingSoonStrip() {
  const { t } = useI18n();
  return (
    <div className="soon-strip" role="status">
      <div className="container">
        <strong>{t("soon.title")}</strong> · {t("soon.strip")}
      </div>
    </div>
  );
}

/** Admins and beta testers browsing the store before it opens: a reminder that it is not public yet. */
export function PreviewStrip() {
  const { t } = useI18n();
  return (
    <div className="soon-strip preview-strip" role="status">
      <div className="container">
        <strong>{t("soon.previewTitle")}</strong> · {t("soon.previewText")}
      </div>
    </div>
  );
}

/** Replaces closed routes (checkout, account, orders). */
export function ComingSoonPage() {
  return <ComingSoonHero />;
}
